import { isSalesforceV2Step } from "components/ConfigureStep/SalesforceSteps/salesforceStepModel";
import { isSalesforceV2Trigger } from "components/ConfigureStep/SalesforceTriggers/salesforceTriggerModel";
import { IStepTool } from "./IStepTool";

/**
 * Who is offered the Salesforce v2 triggers (Opportunity stage change, added to a
 * Campaign) and steps (Update field, Create Task, Add to and Remove from
 * Campaign) in the toolbox: an account that has Salesforce connected, is on the
 * new Salesforce sync (v2) and is on a plan that includes Salesforce. Everyone
 * else does not see them at all. The server refuses the same accounts (the
 * trigger routes answer 409 for v2 and 403 for the plan, the step routes 403
 * for both), so this only hides the buttons.
 *
 * Only the toolbox list is filtered. The tools stay in the tool table for every
 * account (Tools/currentTools), because a flow that already has one of these
 * triggers or steps must still draw it.
 */

/**
 * Whether the plan includes Salesforce, the rule the server applies
 * (planIncludesSalesforce in packages/domain): an account on the Growth tier
 * needs the AppSumo Salesforce add-on, every other account is not held back by
 * its plan. A trial counts as Premium; the account store already says so.
 */
export const planIncludesSalesforce = ({
  tier,
  canUseSalesforce,
}: {
  tier: string | undefined;
  canUseSalesforce: boolean | undefined;
}): boolean => tier !== "growth" || Boolean(canUseSalesforce);

/** Whether a tool is one of the Salesforce v2 triggers or steps. */
export const isSalesforceV2Tool = (tool: IStepTool): boolean =>
  isSalesforceV2Trigger(tool) || isSalesforceV2Step(tool);

/** The tools the toolbox lists: the Salesforce v2 triggers and steps only when `allowed`. */
export const withoutSalesforceV2Tools = (
  tools: IStepTool[],
  allowed: boolean
): IStepTool[] =>
  allowed ? tools : tools.filter((tool) => !isSalesforceV2Tool(tool));
